import React, { Component } from 'react'
import { Typography, Form, Input, Select, Switch, Button } from 'antd'
import { MinusCircleOutlined } from '@ant-design/icons'
import SelectEditable from '../SelectEditable'

export type GenericListField = {
  name: string,
  label: string,
  type: 'text' | 'number' | 'select' | 'boolean',
  custom?: boolean,
  disabled?: boolean,
  options?: [{
    label: string,
    value: string
  }]
  render?: (field: GenericListField, fieldName: string[], props: any) => any
}

type GenericListProps = {
  listName: string
  label: string,
  fields: GenericListField[],
  fieldsLabel?: 'initial' | 'all' | 'none'
  description?: string | React.ReactNode,
  form?: any,

  canAdd?: boolean,
  canRemove?: boolean
}

export default class GenericList extends Component<GenericListProps> {

  static defaultProps = {
    canAdd: true,
    canRemove: true
  }

  private renderInput = (field: GenericListField, fieldName: string[]) => {
    const { listName, form } = this.props

    if (field.render) {
      return field.render(field, fieldName, this.props)
    }

    if (field.type === 'select' && field.options instanceof Array) {

      if (field.custom && form) {
        return (
          <SelectEditable
            editable={field.custom}
            disabled={field.disabled || false}
            name={[listName, ...fieldName]}
            options={field.options}
            form={form}
          />
        )
      }

      // Select fallback
      return (
        <Select
          allowClear={true}
          disabled={field.disabled || false}
          options={field.options}
        />
      )
    }
    if (field.type === 'boolean') {
      return <Switch disabled={field.disabled || false} />
    }
    if (field.type === 'number') {
      return <Input type="number" placeholder={field.label} disabled={field.disabled || false} />
    }

    return <Input placeholder={field.label} disabled={field.disabled || false} />
  }

  private renderFields = (formField: any, index: number) => {
    const { listName, fields, fieldsLabel } = this.props

    return fields.map((field) => {
      const fieldName = [formField.name, field.name]
      let fieldLabel: string | undefined = undefined

      if (!fieldsLabel || fieldsLabel === 'all' || (fieldsLabel === 'initial' && index === 0)) {
        fieldLabel = field.label
      }

      if (field.render) {
        return (
          <Form.Item
            key={[listName, 'field', formField.fieldKey, field.name].join('.')}
            label={fieldLabel}
            shouldUpdate={(prevValues, currentValues) => {
              const prevItem = prevValues[listName]?.[formField.name]
              const currentItem = currentValues[listName]?.[formField.name]
              return JSON.stringify(prevItem) !== JSON.stringify(currentItem)
            }}
            style={{
              marginBottom: 5,
              marginRight: 20,
              width: '100%'
            }}
          >
            {() => (
              <Form.Item
                {...formField}
                name={fieldName}
                valuePropName={field.type === 'boolean' ? 'checked' : undefined}
                noStyle
              >
                {this.renderInput(field, fieldName)}
              </Form.Item>
            )}
          </Form.Item>
        )
      }

      return (
        <Form.Item
          {...formField}
          key={[listName, 'field', formField.fieldKey, field.name].join('.')}
          label={fieldLabel}
          name={fieldName}
          valuePropName={field.type === 'boolean' ? 'checked' : undefined}
          style={{
            marginBottom: 5,
            marginRight: 20,
            width: '100%'
          }}
        >
          {this.renderInput(field, fieldName)}
        </Form.Item>
      )
    })
  }

  render() {
    const { listName, label, canAdd, canRemove, description } = this.props

    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginBottom: 30 }}>
        <Typography.Title level={5}>{label}</Typography.Title>
        {description && typeof description === 'string' && <Typography.Text>{description}</Typography.Text>}
        {description && typeof description !== 'string' && description}
        <Form.List name={listName}>
          {(fields, { add, remove }) => {
            return (
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                {
                  fields.map((field, index) => (
                    <div key={[listName, field.name].join('.')} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      {this.renderFields(field, index)}

                      {
                        canRemove ? (
                          <Button
                            type="dashed"
                            shape="circle"
                            icon={<MinusCircleOutlined />}
                            onClick={() => remove(field.name)}
                            style={{
                              marginTop: 20
                            }}
                          />
                        ) : null
                      }
                    </div>
                  ))
                }

                {
                  canAdd ? (
                    <Button type="dashed" onClick={() => add()} style={{ marginTop: 5 }} block>
                      Add
                    </Button>
                  ) : null
                }
              </div>
            )
          }}
        </Form.List>
      </div>
    )
  }
}
